import clsx from 'clsx';

import styles from './Skeleton.module.scss';

interface SkeletonProps {
  className?: string;
}

const Skeleton = (props: SkeletonProps) => {
  const { className } = props;

  return <div className={clsx(styles.skeleton, className)} />;
};

export default Skeleton;
